import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles/index.module.scss';

const NavContainer = ({ children, className }) => {
  const navClassName = cn(styles.navigation, className);

  return <nav className={navClassName}>{children}</nav>;
};

NavContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

NavContainer.defaultProps = {
  className: undefined,
};

NavContainer.displayName = 'NavContainer';

export default NavContainer;
